import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppContainer from './containers/AppContainer';
import registerServiceWorker from './registerServiceWorker';

import {Provider} from "react-redux";
import store from './store';

import { unregister } from './registerServiceWorker';
unregister();

const Root = () => {
  return (
  	<Provider store={store}>
    	<AppContainer/>
     </Provider>
  )
}

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js